export default __webpack_public_path__ + "static/media/bg01.98e3037a.jpg";